<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
        <!-- Alert message -->
        <div>
          <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{alert_message}}</v-alert>
        </div>
        <loading :active.sync="isLoading" 
          :can-cancel="true" 
          :is-full-page="fullPage" :color="primary_code" />
        <!-- Header-->
        <header-component :headerTitle="headerText" />
        <v-snackbar
          v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :top="snackbar.position === 'top'">
          <v-layout align-center pr-4>
            <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
            <v-layout column>
              <div>{{ snackbar.text }}</div>
            </v-layout>
          </v-layout>
          <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-snackbar>
        <v-card class="v-card-100 mt-4">
          <v-tabs v-model="tab_index">
            <v-tab class="component-tab-heading"ripple :href="'#'" @click="loadData(tab, 'tab_clicked')"
              style="text-transform:none!important;text-decoration: none;" v-for="(tab, index) in tabs"
              :key="index">{{ tab }}</v-tab>
          </v-tabs>
        </v-card>
    
        <!-- seacrh, action button and filter -->
        <v-card-title class="action-style pb-0">
          <!-- Search fields -->
          <v-row class="my-5 mx-2 mb-3">
            <v-autocomplete v-model="select_field" :items="select_field_items" label="Select Field" variant="outlined" style="max-width: 150px;" class="mr-4 text-left"> </v-autocomplete>
            <v-text-field  prepend-inner-icon="mdi-magnify" v-model="search_tag" v-no-edge-space label="Search" style="max-width: 270px;" variant="outlined" v-on:keyup.enter="loadData(active_tab)" :disabled="!select_field"></v-text-field>
              <v-spacer></v-spacer>
            <v-card-actions style="margin-top: -18px;">
              <v-btn class="mr-2 custum-button" variant="flat" v-if="active_tab === 'Reports'" @click="openPopup(items)" color="primary" size="large" style="min-height:55px; min-width:130px; font-weight:600;">Create Report</v-btn>
              <v-btn class="mr-2 custum-button" variant="flat" v-if="active_tab === 'Template'" @click="openPopup(items)" color="primary" size="large" style="min-height:55px; min-width:130px; font-weight:600;">Create Template</v-btn>
            </v-card-actions>
          </v-row>
        </v-card-title>
        <v-layout class="ma-0 pa-0 overflow-y-auto overflow-x-hidden" wrap :style="{height: reportCardHeight}">
        <v-flex class="ma-0 pa-0" xs12 style="width:100%;">
          <v-row align="center" class="ma-1 pb-8">
            <v-col v-for="(item, index) in items" :key="item.id" block :cols="getCols()" xs12>
              <v-card class="rounded-card" :elevation="4">
                <v-row class="ma-0 pa-0" @click="">
                  <v-col class="ma-0 pa-0" justify="center" xs12 :cols="12">
                    <v-row align="center" style="margin:20px 25px 30px; cursor: pointer;"  @click="openViewReportTemplate(item)">
                      <v-col class="text-left p-0 d-flex" cols="8">
                        <img src="@/assets/images/icons/line.png" max-width="18" max-height="18" alt="icon" class="ma-1 mr-2"></img>
                        <h4 style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000">
                          <!-- {{ item.name }} -->
                          <span v-if="item.name && item.name.length <= 20">
                            {{ item.name }}
                      </span>
                      <span v-else-if="!item.name">
                        -
                      </span>
                      <span v-else>
                        <v-tooltip top>
                          <template v-slot:activator="{ props }">
                            <a v-bind="props" style="display: inline-block; margin: 0; font-size: 1.2rem; white-space: nowrap; color:#000000;font-weight:400;">
                              <span>{{ item.name.substring(0, 15) }}...</span>
                            </a>
                          </template>
                          <div style="max-width: 280px !important; word-wrap: break-word !important;">{{ item.name }}</div>
                        </v-tooltip>
                      </span>
                        </h4>
                      </v-col>
                      <v-col class="text-right p-0" cols="4">
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-col>
                    </v-row>
                    <v-row class="ma-0 pa-3" style="background: #F6F6FB;">
                      <v-col class="p-0">
                        <div class="text-center" @click.prevent="toggleDropdown(item)" style="cursor: pointer;">
                          <a href="#" style="color: #003C9E; cursor: pointer; text-decoration: none;">
                             View {{ active_tab }}
                          </a>
                        </div>
                        <v-menu v-model="item.menupopup" v-if="active_tab === 'Reports'" :close-on-content-click="false" offset-y rounded class="w-100">
                          <template v-slot:activator="{ props }">
                            <span v-bind="props"></span>
                          </template>
                          <v-list class="pt-0" :style=" (index+1)%(12/getCols()) ? 'position: relative !important; left: -50% !important;' : 'position: relative !important; left: 50% !important;'">
                        <!-- <v-list-item> -->
                          <v-card class="v-card-100 pa-3">
                            <v-row class="mx-2">
                              <span style="font-size: 16px; font-weight: 500;">Report Name</span>
                              <v-spacer />
                              <v-icon @click="item.menupopup = false">mdi-close</v-icon>
                            </v-row>
                          </v-card>
                        <!-- </v-list-item> -->
                          <div style="height: 250px; max-width: 360px; overflow-y: auto;">
                            <v-list-item-group v-if="reports.length">
                              <v-list-item v-for="(report, index) in reports" :key="index">
                                <v-row class="w-100 pr-0">
                                  <v-col cols="10">
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        <span style="font-size: 12px;">
                                          <!-- {{ report.name }} -->
                                          <span v-if="report.name && report.name.length <= 35">
                                            {{ report.name }}
                                          </span>
                                          <span v-else-if="!report.name">
                                            -
                                          </span>
                                          <span v-else>
                                            <v-tooltip top>
                                              <template v-slot:activator="{ props }">
                                                <a v-bind="props" style="color: #000000;">
                                                  {{ report.name.substring(0, 35) }}...
                                                </a>
                                              </template>
                                              <div style="max-width: 280px !important; word-wrap: break-word !important;">{{ report.name }}</div>
                                            </v-tooltip>
                                          </span>
                                        </span>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-col>
                                  <v-col cols="2">
                                    <v-list-item-action>
                                      <v-icon @click="downloadReport(report)" class="cursor-pointer">mdi-tray-arrow-down</v-icon>
                                    </v-list-item-action>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                            </v-list-item-group>
                            </div>
                            <v-list-item-group class="text-center pt-4" v-if="!reports.length">Report Not available</v-list-item-group>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    
      <v-row justify="center">
        <v-dialog v-model="viewTempReportPopup" persistent max-width="700px">
          <v-card class="v-card-100">
            <v-card class="v-card-100 mt-0 mb-0">
              <v-card-title class="pa-3">
              <v-row class="ma-1">
                <span>{{ active_tab == 'Reports' ? 'Report Details' : 'View Template'  }}</span>
                <span class="view_report_css">{{ active_tab == 'Reports' ? viewDetails.report_name : viewDetails.template_name }}</span>
                <v-spacer></v-spacer>
                <!-- <v-btn icon @click="viewTempReportPopup = false"> -->
                  <v-icon @click="viewTempReportPopup = false">mdi-close</v-icon>
                <!-- </v-btn> -->
              </v-row>
              </v-card-title>
            </v-card>
            <v-card-text class="overflow-auto" style="max-height:400px;">
              <v-tabs v-model="sub_tab_index" style="margin: -10px 0px 0px -10px;" v-if="active_tab == 'Reports'">
              <v-tab class="component-tab-heading"ripple :href="'#'" @click="sub_active_tab = tab"
                style="text-transform:none!important;text-decoration: none;" v-for="(tab, index) in sub_report_tab"
                :key="index">{{ tab }}</v-tab>
            </v-tabs>
            <div v-if="sub_active_tab == 'Report Details' || active_tab == 'Template'">
              <p style="font-weight: 600; font-size: 16px; line-height: 22.4px;margin-top: 18px;">Template Details</p>
              <v-row>
                <v-col cols="3" class="pb-0">
                  <span class="sub_heading_css">Schema</span>
                </v-col>
                <v-col cols="9" class="pb-0">
                  <span class="sub_header_value">{{ viewDetails.schema_name }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <span class="sub_heading_css">Template Name</span>
                </v-col>
                <v-col cols="9">
                  <span class="sub_header_value">{{ viewDetails.template_name }}</span>
                </v-col>
              </v-row>
              <p class="pt-2 pb-4" style="font-weight: 600; font-size: 16px; line-height: 22.4px;">Item info Detail's</p>
              <v-row style="border: 1px solid #E2E3ED;border-radius: 8px;" class="mx-0">
                <v-col cols="4" v-for="(item,index) in merged_fields()" class="bottom_border sub_header_value">
                  {{ item.value }}
                </v-col>
              </v-row>
            </div>
            <div v-if="sub_active_tab == 'Access Control' && active_tab != 'Template'">
              <p style="font-weight: 600; font-size: 16px; line-height: 22.4px;margin-top: 18px;">Template Details</p>
              <v-row>
                <v-col cols="3">
                  <span class="sub_heading_css">Access Control</span>
                </v-col>
                <v-col cols="9">
                  <span class="sub_header_value">{{ viewDetails.access_roles ? viewDetails.access_roles.join(", ") : '-' }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <span class="sub_heading_css">Start Date</span>
                </v-col>
                <v-col cols="9">
                  <span class="sub_header_value">{{ viewDetails.start_date ? viewDetails.start_date : '-' }}</span>
                </v-col>
              </v-row>
              <v-row></v-row>
              <v-row>
                <v-col cols="3">
                  <span class="sub_heading_css">Report Range</span>
                </v-col>
                <v-col cols="9">
                  <span class="sub_header_value">{{ viewDetails.report_range ? viewDetails.report_range[0].toUpperCase() + viewDetails.report_range.slice(1)  : '-'}}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <span class="sub_heading_css">Repeat Every</span>
                </v-col>
                <v-col cols="9">
                  <span v-if="viewDetails.period && viewDetails.repeat_frequency" class="sub_header_value">{{ viewDetails.repeat_frequency }} {{ viewDetails.period[0].toUpperCase() + viewDetails.period.slice(1) }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <span class="sub_heading_css">Repeat On</span>
                </v-col>
                <v-col cols="9">
                  <span class="sub_header_value">{{ viewDetails.weekdays ? viewDetails.weekdays.split(',').join(', ') : '-' }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <span class="sub_heading_css">Frequency</span>
                </v-col>
                <v-col cols="9">
                  <span class="sub_header_value">{{ viewDetails.report_delivery_times ? updateFreq24Hr(viewDetails.report_delivery_times) : '-' }}</span>
                  <v-icon color="error" v-if="viewDetails.report_delivery_times" class="ml-1 mb-1" @click="delete_freqreq">mdi-trash-can-outline</v-icon>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <span class="sub_heading_css">Notification</span>
                </v-col>
                <v-col cols="9">
                  <span class="sub_header_value">{{ viewDetails.notification_type ? viewDetails.notification_type[0].toUpperCase() + viewDetails.notification_type.slice(1)  : '-'}}</span>
                </v-col>
              </v-row>
            </div>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn small variant="outlined" color="primary" class="mb-3 text-none" @click="viewTempReportPopup = false">Cancel</v-btn>
                <v-btn v-if="active_tab == 'Template'" small variant="flat" color="primary" class="mb-3 text-none" @click="editReportTemplate('Clone')">Clone</v-btn>
                <v-btn small variant="flat" color="primary" class="mb-3 text-none" @click="editReportTemplate('Edit')">Edit</v-btn>   
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    
    </v-card>
    </template>
    <script>
    import HeaderComponent from "../../../commoncomponents/HeaderComponent.vue";
    import Loading from 'vue-loading-overlay';
    export default{
        data() {
            return {
                headerText: "Report Creator",
                alert : false,
                alert_type : "success",
                alert_message : '',
                viewReportPopup: false,
                snackbar: false,
                active_tab:'',
                snackbar: {
                    color: null,
                    icon: null,
                    mode: null,
                    position: "top",
                    text: null,
                    timeout: 7500,
                    title: null,
                    visible: false
                    },
                    items: [],
                    
                tabs:[
                    "Reports",
                    "Template"
                    ], 
                tab_index: 0,
                select_field_items:["Report"],
                select_field:'Report',
                search_tag: '',
                active_tab_condi:'',
                organization_name:'',  
                viewTempReportPopup : false,
                viewDetails : '',
                sub_report_tab : ["Report Details","Access Control"],
                sub_active_tab : 'Report Details',
                sub_tab_index : 0,
                isLoading: false,
                fullPage: true,
                primary_code: "#0275d8",
                reportCardHeight: '400px'

            }
        },
        components: {
            HeaderComponent,Loading
          },
        mounted() {
          this.calculateTableHeight();
          window.addEventListener('resize', this.calculateTableHeight);
        },
        beforeUnmount() {
          window.removeEventListener('resize', this.calculateTableHeight);
        },
        async created(){
          this.active_tab_condi = this.$store.state.active_tab;
          this.organization_name = this.$store.state.organization_name;
          const message = this.$store.state.responseMessage
          if(message){
            this.$toast.success(message)
            this.$store.commit('setMessage', { 
              responseMessage: '',
              action: ''
            });
          }
          if(this.active_tab_condi === 'Template'){
            this.tab_index = 1;
            this.loadData('Template');
          }else{
            this.tab_index = 0;
            this.loadData('Reports');
          }
        },
        methods: {
            calculateTableHeight() {
              const viewportHeight = window.innerHeight;
              const additionalSpace = 252;
              const height = viewportHeight  - additionalSpace;
              this.reportCardHeight = height + 'px';
            },
            showAlert(alert_type, alert_message) {
                this.alert = true;
                this.alert_type = alert_type;
                this.alert_message = alert_message;
                this.scrollToTop();
                this.alertTimeOut();
            },
            alertTimeOut() {
                setTimeout(() => {
                    this.alert = false;
                }, 3000);
            },
            scrollToTop() {
                window.scrollTo({
                top: 0,
                behavior: 'smooth',
                });
            },
            openPopup(item){
              if(this.active_tab === 'Reports'){
                  this.$store.commit("setLotIds", {
                  lotIds: this.headerText,
                  inventoryId: this.active_tab,
                  action:'Create Report'
                });
                this.$router.push({ name: 'reportCreator' });
                }else if(this.active_tab === "Template"){
                  this.$store.commit("setLotIds", {
                  lotIds: this.headerText,
                  inventoryId: this.active_tab,
                  action:'Create Template'
                });
                this.$router.push({ name: 'templateCreator' });
                }
            },
            viewReport(){
              this.viewReportPopup = true;
            },
            toggleDropdown(item) {
              if(this.active_tab == 'Template'){
                this.openViewReportTemplate(item)
                return
              }
              this.$httpSecured
              .get(`/api/v2/report_builders/get_generated_reports?report_id=${item.id}`)
              .then(response => {
                this.reports = response.data.reports.map(data => ({
                name: item.name + ' | ' + data[1].split('/').reverse()[0],
                url : data[1]
                }))
                if(this.reports.length)
                  item.menupopup = !item.menupopup;
                else this.$toast.error("Report not available !")
              })
              .catch(error => {
                this.showAlert("error", error.response.data.error);
              });
            },
            downloadReport(report) {
              const link = document.createElement('a');
              link.href = report.url;
              link.setAttribute('download', `${report.name}.csv`);
              document.body.appendChild(link);
              link.click();
            },
            loadData(tab,tab_action){
                if(tab_action){
                  this.search_tag = '';
                  this.select_field = '';
                }
                this.$store.commit('setActiveTab',{ 'active_tab' : tab});
                this.active_tab = tab
                if (tab == "Reports"){
                this.select_field_items = ["Report"]
                this.select_field = 'Report'
                this.getReports();
                }
                if(tab == "Template"){
                  this.select_field_items = ["Template"]
                  this.select_field = 'Template'
                  this.getTemplates();
                }        
              },
            getReports() {
              this.isLoading = true;
              const params ={
                search : this.search_tag
              }
              this.$httpSecured
              .get('/api/v2/report_builders/get_report_names',{params : params})
              .then(response => {
                if (response.data) {
                  this.items = response.data.reports.map(report => ({
                    id: report[0],
                    name: report[1],
                    menupopup: false,
                  }));
                      this.isLoading = false;
                    } else {
                  this.isLoading = false;
                  this.showAlert("error", "No Data Found");
                }
              })
              .catch(error => {
                this.showAlert("error", error.response.data.error);
                this.isLoading = false;
              });
             },
             getTemplates() {
              this.isLoading = true;
              const params ={
                search : this.search_tag
              }
              this.$httpSecured
                .get('/api/v2/report_builders/get_templates',{params : params})
                .then(response => {
                  if (response.data) {
                    this.items = response.data.templates.map(template => ({
                      id: template[0],
                      name: template[1],
                      menupopup: false,
                    }));            
                    this.isLoading = false;
                  } else {
                    this.isLoading = false;
                    this.showAlert("error", "No Data Found");
                  }
                })
                .catch(error => {
                  this.showAlert("error", error.response.data.error);
                  this.isLoading = false;
                });
             },
             openViewReportTemplate(item,path){
              this.isLoading = true
              if(this.active_tab === 'Template'){
                const api = `/api/v2/report_builders/view_template?id=${item.id}`
                this.$httpSecured
                .get(api)
                .then(response => {
                  this.viewTempReportPopup = true;
                  this.isLoading = false
                  this.viewDetails = response.data
                  this.viewDetails.id = item.id
                })
                .catch(error => {
                  this.isLoading = false
                  this.showAlert("error", error.response.data.error);
                });
            } else {
            if(!path){
              this.sub_active_tab = 'Report Details'
              this.sub_tab_index = 0
            }
            const api = `/api/v2/report_builders/show_report_configurations?id=${item.id}`
            this.$httpSecured
            .get(api)
            .then(response => {
              this.viewTempReportPopup = true;
              this.isLoading = false
              this.viewDetails = response.data
              this.viewDetails.id = item.id
            })
            .catch(error => {
              this.isLoading = false
              this.showAlert("error", error.response.data.error);
            });
              }
              
            },
            editReportTemplate(value){
              const updatedViewDetails = { ...this.viewDetails, clone: value };
              this.$store.commit("setLotIds", {
                lotIds:updatedViewDetails,
                inventoryId: this.active_tab,
                action:`Edit ${ this.active_tab == 'Reports' ? 'Report' : 'Template'}`
            });
              this.$router.push({ name: this.active_tab == 'Reports' ? 'reportCreator' : 'templateCreator' });
            },
            getCols() {
              const width = window.innerWidth;
              if (width > 1600) {
                return 3;
              } else if (width > 1400) {
                return 4; 
              }
              return 4;
            },
            updateFreq24Hr(time){
              var timeFormat = ''
              time.split(',').forEach(data => {
                const [hour, minute] = data.split(':').map(Number);
                const ampm = hour >= 12 ? 'PM' : 'AM';
                const hour12 = hour % 12 || 12;
                timeFormat  = timeFormat ? timeFormat + ', ' +  `${hour12}:${String(minute).padStart(2, '0')} ${ampm}` : `${hour12}:${String(minute).padStart(2, '0')} ${ampm}`;
              })
              return timeFormat;
            },
        delete_freqreq(){
          const params = {
            'report_name' : this.viewDetails.report_name,
            'template_name' : this.viewDetails.template_name,
            'schema_name' : this.viewDetails.schema_name,
            'column_names' : this.viewDetails.column_names,
            'access_roles' : this.viewDetails.access_roles,
            'recipient_emails' : this.viewDetails.emails,
            'notification_type' : this.viewDetails.notification_type,
            'start_date' : this.viewDetails.start_date,
            'period' : this.viewDetails.period,
            'report_delivery_times' : '', 
            'repeat_frequency' : this.viewDetails.repeat_frequency,
            'template_id' : this.viewDetails.template_id,
            'query_parameter' : this.viewDetails.query_parameter,
            'report_range' : this.viewDetails.report_range,
          }
          this.isLoading = true
          this.$httpSecured
          .put(`/api/v2/report_builders/update_report_configurations?id=${this.viewDetails.id}`, params )
          .then(response => {
            this.isLoading = false
            this.openViewReportTemplate(this.viewDetails,'freq_update')
            this.$toast.success(response.data.message)
          })  
          .catch(error => {
            this.isLoading = false
            this.$toast.error(error.response.data.error);
          });
        },
        merged_fields(){
          const lists = []
          this.viewDetails.custom_fields?.forEach(item => lists.push({key: item.field_name, value: item.heading}))
          this.viewDetails.summary_columns?.forEach(item => lists.push({key: item.field_name, value: item.heading}))
          this.viewDetails.selected_columns?.forEach(item => lists.push({key: item.field_name, value: item.heading}))
          this.viewDetails.summary_rows?.forEach(item => lists.push({key: item.field_name, value: item.heading}))
          return lists
        }
      }
    }
    </script>
    <style scoped>
    .rounded-card{
        border-radius: 12px;
        overflow: hidden;
    }
    .sub_heading_css{
      font-size: 14px;
      font-weight: 600;
      line-height: 16.94px;
    }
    .bottom_border{
      border-bottom: 1px solid #E2E3ED;
    }
    .sub_header_value{
      font-size: 14px;
      font-weight: 400;
      line-height: 16.94px;
      color: #0C0C0C;
    }
    .view_report_css{
      background: #E0E1EB;
      margin-left: 12px;
      padding: 8px 12px;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 400;
      line-height: 17.4px;
    }
        
    </style>